import React, { Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import PulsingLogo from "./components/PulsingLogo";

const Image = React.lazy(() => import("./components/image"));
const Main = React.lazy(() => import("./components/main"));
const Mycard = React.lazy(() => import("./components/mycard"));
const Homepage = React.lazy(() => import("./components/tmp"));
const Blog = React.lazy(() => import("./components/blog"));
const BlogDetails = React.lazy(() => import("./components/blogDetails"));
const Templates = React.lazy(() => import("./components/templates"));
const Template = React.lazy(() => import("./components/template"));
const PrivacyPolicy = React.lazy(() => import("./components/privacyPolicy"));
const Tnc = React.lazy(() => import("./components/tnc"));
const GeneralPolicies = React.lazy(() => import("./components/generalPolicies"));
const DownloadVideoPage = React.lazy(() => import("./components/utils/downloadVideoPage"));

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><PulsingLogo size={80} /></div>}>
          <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/policies/generalpolicies" element={<GeneralPolicies />} />
          <Route path="/policies/termsofuse" element={<Tnc />} />
          <Route path="/policies/privacypolicy" element={<PrivacyPolicy />} />
          <Route
            path="/wedding-card/browse-page/:type/:template_id"
            element={<Image />}
          />
          <Route path="/wedding-card/mycard" element={<Mycard />} />
          <Route path="/wedding-card/pages" element={<Homepage />} />
          <Route path="/wedding-card/blogs" element={<Blog />} />
          <Route path="/wedding-card/blog/:id" element={<BlogDetails />} />
          <Route path="/wedding-card/templates" element={<Templates />} />
          <Route
            path="/wedding-card/template/:type/:template_id"
            element={<Template />}
          />
          <Route
            path="/wedding-card/template/:template_id"
            element={<Template />}
          />
          <Route path="/download/:orderId" element={<DownloadVideoPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
